export const PREFIX_PELATIHAN_BCKS = 'Program Pelatihan BCKS'

export const FUND_SOURCE_TAG_CODE = {
  APBN: 'APBN',
  APBD: 'APBD',
  Yayasan: 'Yayasan',
} as const
